<div class="container-imageSlider" id="{{viewData.id}}" #slider>
    <h2 id="{{viewData.id}}-title">{{viewData.title}}</h2>

    <div class="container-btn previous" [hidden]="(viewData.slide.length <= 1) || !showControls">
        <button type="button" aria-label="previous" (click)="moveCarousel('previous')" [disabled]="isPreviousDisabled">
            <svg class="gr-left-open" xmlns="http://www.w3.org/2000/svg">
                <use xlink:href="./assets/img/icons.svg#gr-left-open"></use>
            </svg>
        </button>
    </div>

    <div class="container-btn next" [hidden]="(viewData.slide.length <= 1) || !showControls">
        <button type="button" aria-label="next" (click)="moveCarousel('next')" [disabled]="isNextDisabled">
            <svg class="gr-right-open" xmlns="http://www.w3.org/2000/svg">
                <use xlink:href="./assets/img/icons.svg#gr-right-open"></use>
            </svg>
        </button>
    </div>

    <div class="viewport">
        <div class="container-items" [ngStyle]="itemsContainerStyleObject">
            <ul [ngStyle]="itemsContainerStyleObject">
                <li *ngFor="let slide of viewData.slide" >
                    <article>
                        <a (click)="pushSuggestedImageToGA(slide)" [routerLink]="slide.url"  [attr.aria-describedby]="(viewData.id) + '-title'" [ngStyle]="{ 'background-image': 'url(' + slide.imgUrl + ')' }">
                            <div class="txt-sliderItemLabel">{{slide.label}}</div>
                        </a>
                    </article>
                </li>
            </ul>
        </div>
    </div>
</div>
